export default __webpack_public_path__ + "static/media/55875029_2093634227392656_733480169620111360_n.4c7d7228.jpg";